import { RaceStatus } from 'src/config/types.ts';
import type { TFunction } from 'i18next';

export function getRaceStatusLabel(raceStatus: RaceStatus, t: TFunction): string {
  switch (raceStatus) {
    case RaceStatus.Starting:
      return t('karwa.event.race.result.race_status.starting');
    case RaceStatus.Complete:
      return t('karwa.event.race.result.race_status.complete');
    case RaceStatus.Dnf:
      return t('karwa.event.race.result.race_status.dnf');
    case RaceStatus.Dnq:
      return t('karwa.event.race.result.race_status.dnq');
    case RaceStatus.Dns:
      return t('karwa.event.race.result.race_status.dns');
    case RaceStatus.InProgress:
    default:
      return t('karwa.event.race.result.race_status.in_progress');
  }
}
